import React from 'react'
import { Switch, useRouteMatch } from 'react-router-dom'
import { SecureRoute } from '@okta/okta-react'
import NotFoundView from '../common/NotFoundView'
import SkillsHome from './Home'

function Skills () {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <SecureRoute path={`${path}`} exact>
        <SkillsHome />
      </SecureRoute>
      <SecureRoute path='*'>
        <NotFoundView />
      </SecureRoute>
    </Switch>
  )
}

export default Skills
